import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-783f2534"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-footer-bar-element" }
const _hoisted_2 = { class: "info left" }
const _hoisted_3 = { class: "selected" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Selected:", -1))
const _hoisted_5 = { class: "info right" }
const _hoisted_6 = {
  key: 0,
  class: "page-check valid"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "✓", -1))
const _hoisted_8 = {
  key: 1,
  class: "page-check invalid"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "⚠", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, [
        _hoisted_4,
        _createTextVNode(" " + _toDisplayString(_ctx.hasSelection), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_ctx.isValid)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _hoisted_7,
            _createTextVNode(" Valid " + _toDisplayString(_ctx.fileName), 1)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _hoisted_9,
            _createTextVNode(" Invalid " + _toDisplayString(_ctx.fileName), 1)
          ]))
    ])
  ]))
}